"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useItemChooserLoader = exports.initLoaderState = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const react_1 = require("react");
function initLoaderState(partial) {
    return Object.assign({ items: [], keyword: undefined, offset: 0, limit: 25 }, partial);
}
exports.initLoaderState = initLoaderState;
function useItemChooserLoader(state) {
    var _a, _b;
    const { items } = state;
    const result = (0, react_1.useMemo)(() => ({
        totalCount: 0,
        loading: false,
        items: [],
        refetch: doNothing_1.default,
    }), []);
    result.items = items;
    // Filter Array based on Text entered by user
    if (state.keyword) {
        result.items = (_a = result.items) === null || _a === void 0 ? void 0 : _a.filter(i => i.title.toLowerCase().includes(state.keyword.toLowerCase()));
    }
    // Limit array to Offset Limit
    result.items = (_b = result.items) === null || _b === void 0 ? void 0 : _b.slice(0, state.offset + state.limit);
    result.totalCount = items === null || items === void 0 ? void 0 : items.length;
    return result;
}
exports.useItemChooserLoader = useItemChooserLoader;
exports.default = useItemChooserLoader;
